var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.938 6L0 10.938 1.062 12 6 7.062 10.938 12 12 10.938 7.062 6 12 1.062 10.938 0 6 4.938 1.062 0 0 1.062 4.938 6z"
  })));
}

export default __webpack_public_path__ + "315fe4c445e992e6fb6767651008bb9b.svg";
export { SvgCloseModal as ReactComponent };